'use client';

import {useContext} from 'react';
import {
  ActiveScreenIdSubscriptionContext,
  type SetSelectedScreenIds,
} from './ActiveScreenIdProvider';

/**
 * Returns the multi-aware setter for the selected screens array.
 *
 * Pass either a new array or an updater function: setSelectedScreenIds([id])
 * to replace; setSelectedScreenIds(prev => [...prev, id]) to append.
 *
 * Index 0 is the primary active screen and is mirrored to the URL.
 */
export function useSetSelectedScreenIds(): SetSelectedScreenIds {
  return useContext(ActiveScreenIdSubscriptionContext).setSelectedScreenIds;
}
